import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';
import { countByCategory } from '@/lib/videos';

export default function CategoryQuickLinks() {
  return (
    <div id="categories" className="grid grid-cols-2 gap-3 md:grid-cols-3 md:gap-4 lg:grid-cols-6">
      {categories.map((category, index) => (
        <Link
          key={category.slug}
          to={`/category/${encodeURIComponent(category.slug)}`}
          className="group animate-fade-up rounded-lg border border-background-200 bg-background-50 p-4 transition-colors hover:border-primary-300 hover:bg-background-100"
          style={{ animationDelay: `${index * 60}ms` }}
        >
          <span className="flex h-10 w-10 items-center justify-center rounded-md bg-primary-50 text-primary-700 transition-colors group-hover:bg-primary-600 group-hover:text-background-50">
            <i className={`${category.icon} text-lg`} />
          </span>
          <h3 className="mt-3 text-[14px] font-medium text-foreground-950">{category.name}</h3>
          <p className="mt-1 text-[11px] uppercase tracking-[0.12em] text-foreground-400">{category.accent}</p>
          <p className="mt-2.5 flex items-center gap-1 text-[11px] text-foreground-500">
            <span className="flex h-3 w-3 items-center justify-center">
              <i className="ri-film-line text-[11px]" />
            </span>
            {countByCategory(category.name)} 部在架
          </p>
        </Link>
      ))}
    </div>
  );
}